import gql from 'graphql-tag'

export const biocharPage = gql`
 query biocharPage($locale: SiteLocale) {
    biochar(locale: $locale) {
      intro
      title
      subtitle
      seo {
        title
        image {
          url
        }
        description
      }
      imageDesk {
        responsiveImage {
          src
          srcSet
        }
      }
      imageMobile {
        responsiveImage {
          src
          srcSet
        }
      }
      text1
      iconsUtilizzi {
        svg {
          url
        }
        text
      }
      text2
      imagesGrid {
        responsiveImage {
          src
          srcSet
        }
        title
      }
      text3
      microscopeImage {
        responsiveImage {
          src
          srcSet
        }
      }
      text4
      graphsBlock(locale: $locale) {
        responsiveImage {
          src
          srcSet
        }
        title
      }
      text5
      resultsIcons{
        responsiveImage {
          src
          srcSet
        }
      }
      text6
    }
  }
`
